import { subheading } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

// Contentful's Markdoc pipeline treats `{% subheading %}` as inline content, so
// it emits `<p><span class="subheading">…</span></p>`. MDX parses a standalone
// `<Subheading>` as flow content and would drop that paragraph wrapper, which
// changes the rendered DOM and the vertical rhythm relative to the page
// Contentful serves at the same URL. Keep the wrapper here so both pipelines
// produce the same markup.
const MdxSubheading: FC<PropsWithChildren> = ({ children }) => {
  const Component = subheading.component.value as FC<PropsWithChildren>;
  return (
    <p>
      <Component>{children}</Component>
    </p>
  );
};

MdxSubheading.displayName = 'MdxSubheading';

export { MdxSubheading };
